/**
 * Picks the history sentence for a lead field change: a value that was
 * set for the first time or cleared reads differently from a change, so
 * the timeline never prints `von „—“` (DEV-543).
 */
export function pickFieldActivityTemplate(
  from: string | null | undefined,
  to: string | null | undefined,
  templates: { updated: string; set: string; cleared: string },
): string {
  const hasFrom = Boolean(from?.trim());
  const hasTo = Boolean(to?.trim());
  if (!hasFrom && hasTo) return templates.set;
  if (hasFrom && !hasTo) return templates.cleared;
  return templates.updated;
}
